import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import config from "./config"
//import i18n from './i18n'

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		accessToken: localStorage.getItem('accessToken'),
		refreshToken: localStorage.getItem('refreshToken'),
		centerInfo: JSON.parse(localStorage.getItem('centerInfo')) || {},
		alerts:[],
		language: localStorage.getItem('language') || 'kk',
	},

	mutations: {
		login(state, response) {
			state.accessToken = response.data.access_token;
			state.refreshToken = response.data.refresh_token;
			localStorage.setItem('accessToken', state.accessToken);
			localStorage.setItem('refreshToken', state.refreshToken);
			axios.defaults.headers.common['X-Auth'] = state.accessToken;
		},
		setLanguage(state, lang) {
			localStorage.setItem('language', lang);
			state.language = lang;
			//i18n.locale = lang;
		},
		setCenterInfo(state, data) {
			localStorage.setItem('centerInfo', JSON.stringify(data));
			state.centerInfo = data;
		},
		alert(state, {alert, adding}) {
            adding ? state.alerts.push(alert)
				: state.alerts.shift()
		},
		logout(state) {
			state.accessToken = '';
			state.refreshToken = '';
			state.centerInfo = {};
			localStorage.removeItem('centerInfo');
			localStorage.removeItem('accessToken');
			localStorage.removeItem('refreshToken');
			delete axios.defaults.headers.common['X-Auth'];
		}
	},

	actions: {
		changeBaseUrl({getters}) {
			axios.defaults.baseURL = getters.getBaseUrl+getters.getLanguage;
		},
		alertAdd({commit}, alert) {
			commit('alert', { alert, adding: true});
			setTimeout(() => commit('alert', { alert, adding: false }), alert.duration ?? 5000);
		},
		login({commit}, response) {
			return new Promise((resolve) => {
				commit('login', response);
				resolve();
			})
		},
		logout({commit, dispatch}) {
			commit('logout');
			dispatch('changeBaseUrl');
			let url = '/portal/#/login';
			location.href = url;
			location.reload();
		}
	},

	getters: {
		getBaseUrl() {
			return config.API_URL;
		},
		getAccessToken(state) {
			return state.accessToken;
		},
		getRefreshToken(state) {
			return state.refreshToken;
		},
		getCenterInfo(state) {
			return state.centerInfo;
		},
		getLanguage(state) {
			return state.language;
		}
	}

});